module.exports = __webpack_public_path__ + "img/dianji1.ec95e3e6.png";